export default __webpack_public_path__ + "static/DEIPage-pattern-large-yellow-1b16ab6626645d2c71122602506fd7ba.png";